module.exports = __webpack_public_path__ + "img/nlic_gallery11.4cf0f69e.jpg";